<!--
 * @Author: your name
 * @Date: 2020-04-13 15:59:01
 * @LastEditTime: 2020-04-13 19:09:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vueTest\houtai\src\components\nav-top.vue
 -->
<style scoped>
.el-row{
  height: 100%;
}

.el-menu{
  border-right:none;
}
.el-aside{
  border-right: 1px solid #f5f1f1;
  background-color: #fff;
  transition: width 0.3s;
}
.collapse-btn {
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  background-color: #f5f7f9;
  border-bottom: 1px solid #e6e6e6;
  font-size: 18px;
  color: #606266;
}
.collapse-btn:hover {
  background-color: #e6e6e6;
}
</style>

<template>
  <el-aside :width="isCollapse ? '64px' : '200px'">
    <div class="collapse-btn" @click="toggleCollapse">
      <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
    </div>
    <el-row class="tac">
      <el-col>
        <el-menu
          :default-active="activeIndex"
          class="el-menu-vertical-demo"
          :collapse="isCollapse"
          :collapse-transition="false"
          @open="handleOpen"
          @close="handleClose"
        >
          <el-menu-item index="1" @click="goPage('home')">
            <i class="el-icon-menu"></i>
            <span slot="title">后台首页</span>
          </el-menu-item>

          <el-menu-item v-if="canSeeBackendUser" index="backendUserManage" @click="goPage('backendUserManage')">
            <i class="el-icon-s-custom"></i>
            <span slot="title">后台账号管理</span>
          </el-menu-item>

          <el-menu-item v-if="canSeeBackendUser" index="districtMapConfig" @click="goPage('districtMapConfig')">
            <i class="el-icon-map-location"></i>
            <span slot="title">县域地图配置</span>
          </el-menu-item>

          <el-menu-item index="spotManage" @click="goPage('spotManage')">
            <i class="el-icon-s-order"></i>
            <span slot="title">图斑管理</span>
          </el-menu-item>

          <el-menu-item index="spotMonitorManage" @click="goPage('spotMonitorManage')">
            <i class="el-icon-s-order"></i>
            <span slot="title">图斑监测管理</span>
          </el-menu-item>

          <el-submenu index="3">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span>用户管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item @click="goPage('userManage')" index="userManage">管理员管理</el-menu-item>
              <el-menu-item @click="goPage('applyManage')" index="applyManage">申请管理</el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-menu-item v-if="false" index="mineManage" @click="goPage('mineManage')">
            <i class="el-icon-s-order"></i>
            <span slot="title">矿山管理</span>
          </el-menu-item>

          <el-menu-item v-if="false" index="treeManage" @click="goPage('treeManage')">
            <i class="el-icon-s-order"></i>
            <span slot="title">植被管理</span>
          </el-menu-item>

          <el-menu-item v-if="false" index="tipsTplManage" @click="goPage('tipsTplManage')">
            <i class="el-icon-s-order"></i>
            <span slot="title">指导模板管理</span>
          </el-menu-item>

          <el-menu-item index="timeTplManage" @click="goPage('timeTplManage')">
            <i class="el-icon-s-order"></i>
            <span slot="title">时间推送模板管理</span>
          </el-menu-item>

        </el-menu>
      </el-col>
    </el-row>
  </el-aside>
</template>

<script>
var $this = {};
export default {
  props: {
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeIndex: "1",
      canSeeBackendUser: false
    };
  },
  created() {
    this.checkRole();
    this.setActiveIndex();
  },
  watch: {
    $route() {
      this.setActiveIndex();
    }
  },
  methods: {
    checkRole() {
      const userInfoStr = localStorage.getItem("adminUserInfo");
      if (userInfoStr) {
        try {
          const userInfo = JSON.parse(userInfoStr);
          this.canSeeBackendUser = userInfo.role === "SUPER_ADMIN" || userInfo.role === "ADMIN";
        } catch (e) {
          this.canSeeBackendUser = false;
        }
      }
    },
    setActiveIndex() {
      const routeName = this.$route.name;
      if (routeName === 'Home') {
        this.activeIndex = '1';
      } else if (routeName) {
        this.activeIndex = routeName;
      }
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },

    toggleCollapse() {
      this.$emit('toggleCollapse');
    },
    //跳转到某个导航页
    goPage(link) {
      if (link === "home") {
        $this.$router.push("/").catch(error => error);
      } else {
        $this.$router.push("/"+link).catch(error => error);
      }
    }
  },
  beforeCreate() {
    $this = this;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/nav.vue